<app-page
  pageTitle="Rezervacije"
  pageDescription="Upravljanje terminima i kalendarom"
>
  @if (stats(); as stats) {
    <div class="mt-4 flex flex-column">
      <div class="flex flex-wrap align-items-center justify-content-between gap-3">
        <p-tabs class="view-tabs" [value]="viewMode()" (valueChange)="onViewModeChange($event)">
          <p-tablist>
            <p-tab value="list" aria-label="Prikaz liste">
              <app-list width="1.25rem" height="1.25rem"></app-list>
            </p-tab>
            <p-tab value="calendar" aria-label="Prikaz kalendara">
              <app-calendar width="1.25rem" height="1.25rem"></app-calendar>
            </p-tab>
          </p-tablist>
        </p-tabs>
        @if (viewMode() === 'list') {
          <p-tabs [value]="statsOptionSelected" (valueChange)="onPeriodChange($event)">
            <p-tablist>
              <p-tab [value]="AppointmentStatsPeriod.WEEK">
                <div class="text-sm-semibold text-gray-900">7 dana</div>
              </p-tab>
              <p-tab [value]="AppointmentStatsPeriod.MONTH">
                <div class="text-sm-semibold text-gray-900">30 dana</div>
              </p-tab>
              <p-tab [value]="AppointmentStatsPeriod.YEAR">
                <div class="text-sm-semibold text-gray-900">12 meseci</div>
              </p-tab>
            </p-tablist>
          </p-tabs>
        }
      </div>
    </div>
    @if (viewMode() === 'list') {
      <div class="mt-3 flex flex-column md:flex-row gap-4">
        <div class="stat-container flex align-items-center flex-1">
          <div class="stat-icon">
            <app-calendar stroke="#414651"></app-calendar>
          </div>
          <div class="ml-4 flex flex-column">
            <div class="text-sm-semibold text-gray-600">Danas</div>
            <div class="mt-2 display-sm-semibold text-gray-900">{{stats.today}}</div>
          </div>
        </div>
        <div class="stat-container flex align-items-center flex-1">
          <div class="stat-icon">
            <app-check-circle stroke="#414651"></app-check-circle>
          </div>
          <div class="ml-4 flex flex-column">
            <div class="text-sm-semibold text-gray-600">Zakazano</div>
            <div class="mt-2 display-sm-semibold text-gray-900">{{stats.scheduled}}</div>
          </div>
        </div>
        <div class="stat-container flex align-items-center flex-1">
          <div class="stat-icon">
            <app-percent-03 stroke="#414651"></app-percent-03>
          </div>
          <div class="ml-4 flex flex-column">
            <div class="text-sm-semibold text-gray-600">Popunjeno</div>
            <div class="mt-2 display-sm-semibold text-gray-900">{{ formatNumber(stats.bookingPercentage) }}<span class="text-gray-400">&nbsp;%</span></div>
          </div>
        </div>
      </div>
    }
  }
  @if (viewMode() === 'list') {
    <app-admin-appointments-table (onAction)="load()"></app-admin-appointments-table>
  } @else {
    <div class="mt-4">
      <app-admin-appointments-calendar></app-admin-appointments-calendar>
    </div>
  }
</app-page>
